import { IMAGE_PATHS, APP_VERSION } from '/settings.js';

/**
 * Adds version query parameter to URL for cache-busting
 * Matches the logic from static-assets-cache.js to ensure URLs match preloaded assets
 */
function addVersionToUrl(url) {
  if (!APP_VERSION) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${APP_VERSION}`;
}

// Resolve sprite paths with domain awareness:
// ICONS_SPRITE / AREAS_SPRITE override > ICONS/areas.svg > fallback app_core
const SPRITE_PATH = (() => {
  let path;
  if (IMAGE_PATHS && IMAGE_PATHS.ICONS_SPRITE) {
    path = IMAGE_PATHS.ICONS_SPRITE;
  } else if (IMAGE_PATHS && IMAGE_PATHS.ICONS) {
    const base = IMAGE_PATHS.ICONS.endsWith('/') ? IMAGE_PATHS.ICONS : `${IMAGE_PATHS.ICONS}/`;
    path = `${base}icons.svg`;
  } else {
    path = '/app_core/src/images/icons/icons.svg';
  }
  return addVersionToUrl(path);
})();
const AREAS_SPRITE_PATH = (() => {
  let path;
  if (IMAGE_PATHS && IMAGE_PATHS.AREAS_SPRITE) {
    path = IMAGE_PATHS.AREAS_SPRITE;
  } else if (IMAGE_PATHS && IMAGE_PATHS.ICONS) {
    const base = IMAGE_PATHS.ICONS.endsWith('/') ? IMAGE_PATHS.ICONS : `${IMAGE_PATHS.ICONS}/`;
    path = `${base}areas.svg`;
  } else {
    // fallback to icons sprite if areas sprite missing
    // Use SPRITE_PATH which already has version
    return SPRITE_PATH;
  }
  return addVersionToUrl(path);
})();
const SVG_NS = 'http://www.w3.org/2000/svg';
const XLINK_NS = 'http://www.w3.org/1999/xlink';

function normalizeId(id) {
  if (!id) return null;
  const base = id.toString().split('/').pop();
  return base.replace(/\.svg$/i, '');
}

export function createIconElement(id, className = '') {
  const svg = document.createElementNS(SVG_NS, 'svg');
  const classes = ['icon'].concat(className ? className.split(' ').filter(Boolean) : []);
  svg.setAttribute('class', classes.join(' '));
  svg.setAttribute('aria-hidden', 'true');
  const use = document.createElementNS(SVG_NS, 'use');
  use.setAttribute('href', `${SPRITE_PATH}#${id}`);
  use.setAttributeNS(XLINK_NS, 'xlink:href', `${SPRITE_PATH}#${id}`);
  svg.appendChild(use);
  return svg;
}

export function createIconMarkup(id, className = '') {
  const classes = ['icon'].concat(className ? className.split(' ').filter(Boolean) : []);
  const cls = classes.join(' ');
  const href = `${SPRITE_PATH}#${id}`;
  return `<svg class="${cls}" aria-hidden="true"><use href="${href}" xlink:href="${href}"></use></svg>`;
}

export function createAreaIconElement(id, className = '', fallbackId = 'map-location-dot-solid') {
  const iconId = normalizeId(id) || fallbackId;
  const svg = document.createElementNS(SVG_NS, 'svg');
  const classes = ['icon'].concat(className ? className.split(' ').filter(Boolean) : []);
  svg.setAttribute('class', classes.join(' '));
  svg.setAttribute('aria-hidden', 'true');
  const use = document.createElementNS(SVG_NS, 'use');
  use.setAttribute('href', `${AREAS_SPRITE_PATH}#${iconId}`);
  use.setAttributeNS(XLINK_NS, 'xlink:href', `${AREAS_SPRITE_PATH}#${iconId}`);
  svg.appendChild(use);
  return svg;
}

export function createAreaIconMarkup(id, className = '', fallbackId = 'map-location-dot-solid') {
  const iconId = normalizeId(id) || fallbackId;
  const classes = ['icon'].concat(className ? className.split(' ').filter(Boolean) : []);
  const cls = classes.join(' ');
  const href = `${AREAS_SPRITE_PATH}#${iconId}`;
  return `<svg class="${cls}" aria-hidden="true"><use href="${href}" xlink:href="${href}"></use></svg>`;
}
